const batchModCommonObj = {
  data() {
    return {

    };
  },
  methods: {
    setEnabled(refName, arr) {
      arr.forEach((item) => {
        if (item.couldBatchMod) {
          this.$refs[refName].setValidate(item.name, item.validate);
          const temp = this.$refs[refName].$refs.bus.$refs[item.name];
          const dom = document.getElementById(item.name);
          if (dom !== null && item.validate && item.validate.required && item.validate.required[0]) {
            dom.nextElementSibling.classList.add('h-red-code');
            dom.nextElementSibling.innerHTML = '*';
          }
          if (item.type === 'text') {
            temp[0].$refs[item.name].disabled = false;
          } else if (item.type === 'checkbox') {
            temp[0].$refs.checkAll.$el.ej2_instances[0].disabled = false;
            Object.keys(temp[0].$refs).forEach((item) => {
              if (item !== 'checkAll') {
                temp[0].$refs[item][0].$el.ej2_instances[0].disabled = false;
              }
            });
          } else if (item.type === 'select') {
            temp[0].$refs[item.name].$el.ej2_instances[0].enabled = true;
          } else if (item.type === 'date') {
            temp[0].$children[1].$el.ej2_instances[0].enabled = true;
          }
        }
      });
      this.$refs[refName].setDatas(arr);
    },
    setDisabled(refName, arr) {
      arr.forEach((item) => {
        if (item.couldBatchMod) { // 验证规则、不可操作、必填项
          this.$refs[refName].$refs.bus.removeValidate(item.name);
          const dom = document.getElementById(item.name);
          document.getElementById(item.name+'-info') && document.getElementById(item.name+'-info').setAttribute('style', 'display: none');
          if (dom !== null && dom.nextElementSibling &&　dom.nextElementSibling.className === 'h-red-code') {
            dom.nextElementSibling.classList.remove('h-red-code');
            dom.nextElementSibling.innerHTML = '';
          }
          const temp = this.$refs[refName].$refs.bus.$refs[item.name];
          if (item.type === 'text') {
            temp[0].$refs[item.name].disabled = true;
            temp[0].$refs[item.name].classList.remove('e-error');
          } else if (item.type === 'checkbox') {
            temp[0].$refs.checkAll.$el.ej2_instances[0].disabled = true;
            Object.keys(temp[0].$refs).forEach((item) => {
              if (item !== 'checkAll') {
                temp[0].$refs[item][0].$el.ej2_instances[0].disabled = true;
              }
            });
          } else if (item.type === 'select') {
            temp[0].$refs[item.name].$el.ej2_instances[0].enabled = false;
          }　else if (item.type === 'date') {
            temp[0].$children[1].$el.ej2_instances[0].enabled = false;
          }
        }
      });
      this.$refs[refName].setDatas(arr);
    },
    bindCheckbox(refName, arr) {
      arr.forEach((item) => {
        if (!item.batch_hidden && !item.hidden) { // 验证规则、不可操作、必填项
          const dom = document.getElementById(item.name);
          if (dom) {
            dom.classList.remove('h-subscriber-nocheck-style');
            dom.classList.add('h-subscriber-hascheck-style');
            dom.children[0].onchange = this.changeBaseFun;
            dom.children[0].innerValue = item.name;
          }
        }
      });
      this.$refs[refName].setDatas(arr);
    },
  },
};
export default batchModCommonObj;
